import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

const CancellationsRefunds: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <div className="bg-white border-b border-gray-200">
        <div className="max-w-4xl mx-auto px-6 py-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-3">
              <img
                src="/vetriaAI.png"
                alt="VetriaAI Logo"
                className="w-10 h-10"
              />
              <span className="text-2xl font-bold text-gray-900">VetriaAI</span>
            </div>
            <Link
              to="/"
              className="flex items-center text-gray-600 hover:text-gray-900 font-medium"
            >
              <ArrowLeft className="w-4 h-4 mr-2" />
              Back to Home
            </Link>
          </div>
        </div>
      </div>

      <div className="max-w-4xl mx-auto px-6 py-12">
        <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-8">
          <pre className="text-gray-900 font-sans whitespace-pre-line text-base leading-relaxed">
{`VetriaAI Cancellations & Refunds Policy

Last Updated: 09 October 2025

1) Trials & Demos
Free trials:
7-day free trial providing full or limited access.
Auto-convert to paid plans unless cancelled before renewal.
Demos: Complimentary; no charges unless you agree to a paid plan.

2) Subscriptions & Renewals
Payment: Prepaid (monthly or annual).
Auto-renewal: Plans renew automatically at the end of each term.
Cancellation:
Can be done anytime via the billing page.
Stops future renewals but keeps access until the end of the current term.

3) Refunds
Monthly plans: No refunds for partial months.
Annual plans:
Refunds possible within 7 days of first purchase/renewal.
Must have no material usage (no new tests or candidate screenings).
Refund is pro-rated for the remaining unused term.
Downtime credits: Available if monthly uptime <99.9% (per SLA), not cash.
Duplicate charges/billing errors: Fully refunded once verified.
Marketplace/third-party fees: Governed by the third-party policy.

4) Enterprise & Invoiced Customers
Terms of signed agreements override this policy if inconsistent.

5) How to Cancel or Request a Refund
Contact: info@vetriaai.com
 (from admin email) or use the in-app billing portal.
Include:
Workspace name
Plan & term
Order/Invoice ID
Reason for request
Response typically within 2 business days.

6) Chargebacks
Contact VetriaAI before initiating chargebacks.
Unwarranted chargebacks may lead to account suspension.`}
          </pre>
        </div>
      </div>
    </div>
  );
};

export default CancellationsRefunds;
